import { Badge as BadgeCore, IconButton } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors, fonts, measures } from '~/layout';

export const BottomNavigationComponent = lib.styled.div`
    display: flex;
    position: relative;
    flex-direction: row;
    background-color: ${colors.white}!important;
    justify-content: space-around!important;
    height: ${measures.bottomNav.height}px!important;
    border-top: 1px solid ${colors.lightGray06};
    box-shadow: 0 0px 4px 0 rgba(32,33,36,0.18)!important;
    z-index: 1000;

    &::-webkit-scrollbar { width: 0!important; height: 0!important; }
    overflow: -moz-scrollbars-none!important; }
    -ms-overflow-style: none!important; }

    .devMode {
      position: relative;
      top: -22px;
      background-color: ${colors.red03};

      span {
        color: ${colors.white};
        font-size: 10px;
        padding: 10px;
        font-weight: bold;
      }
    }

    a {
      display: flex;
    }

    .nav-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-width: 40px!important;
      width: ${measures.bottomNav.widthItem}px;
      padding: ${measures.reset}px!important;
      span {
        color: ${colors.darkGray08};
        opacity: 1!important;
        font-size: ${fonts.label}px;
        font-weight: 800;
        letter-spacing: 0.012em!important;
      }
    }

    .center {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      .call-button {
        position: absolute;
        top: -15px;
        border: 0;
        box-shadow: none;
        padding: 0;
        margin: 0;
        background: transparent;
        cursor: pointer;
        outline: none;

        .border-one {
          width: 61px;
          height: 61px;
          border: 1px solid ${colors.lightGray06};
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          background: ${props =>
            props.block ? colors.lightGray02 : colors.green02};
          border-radius: 50%;

          .border-two {
            width: 60px;
            height: 60px;
            border: 3px solid ${colors.white};
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            background: ${props =>
              props.block ? colors.lightGray02 : colors.green02};
            border-radius: 50%;

            .icon {
              color: ${colors.white};
              width: 21px;
              height: 21px;
            }
          }
        }
      }

      .disabled {
        pointer-events: none!important;
        .border-two {
          background: ${colors.lightGray02}!important;
        }
      }
    }

    .selected {
      .icon {
        path {
          fill: ${colors.lightBlue};
          fill-opacity: 1!important;
        }
      }
      span {
        color: ${colors.lightBlue};
      }
    }
`;

export const HistoryBadge = lib.styled(BadgeCore)`
  span {
    right: -1px;
    top: 18px;
    width: 13px;
    height: 13px;
    min-width: 13px!important;
    font-size: 8px!important;
    color: ${colors.white}!important;
    padding-left: 7px;
  }
`;

export const IconButtonDiv = lib.styled(IconButton)`
  position: relative;
  width: 50px;
  height: 50px;
  padding: 0px!important;

  &:hover: {
      background-color: ${colors.lightGray};
  };
`;

export const ConverstaionsBadge = lib.styled(BadgeCore)`
  .MuiBadge-badge {
    height: 16px;
    width: 16px;
    background-color: ${colors.red10};
    color: ${colors.white} !important;
    font-size: 8px !important;
  }

  .MuiBadge-anchorOriginBottomRightCircular {
    right: 0%;
    bottom: 90%;
  }
`;
